/*eslint-disable*/
//This file was generated by `tools/generate-error-classes.ts`.
//Changes made to this file will be overwritten.
//Moreover, this file should be excluded from your linter, formatter and VCS.
type PathUnionType = {};
export default class BaseError extends Error {
  public readonly id: number;
  public readonly slug: string;
  public readonly module: string;
  public readonly submodule: string;
  public readonly path: PathUnionType;
  public readonly originalError?: Error;
  constructor(
    id: number,
    slug: string,
    module: string,
    submodule: string,
    path: PathUnionType,
    originalError?: Error
  ) {
    super(slug.toUpperCase());
    this.id = id;
    this.slug = slug;
    this.module = module;
    this.submodule = submodule;
    this.path = path;
    this.originalError = originalError;
  }
}
